import { Component, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { ModalComponent } from '../../../components/modal/modal.component';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'lowy-confirm-datalock',
  template: `
  <lowy-modal #modal>
    <div class="form">
      <div class="headline">Confirm Data Lock</div>
      <div class="subheading">
        <p>Are you sure you want to lock data through {{toDate | date:'mediumDate'}}</p>
        <p>Confirm there are no incomplete packages in this date range.</p>
      </div>
      <div class="row">
        <div class="col-2">
          <button mat-button class="lowy-btn-clear" (click)="cancel()">cancel</button>
        </div>
        <div class="col-2">
          <button mat-button class="lowy-btn-std" (click)="confirm()">confirm</button>
        </div>
      </div>
    </div>
  </lowy-modal>
  `
})
export class ConfirmDatalockModalComponent {
  public toDate: string;

  @Output() confirmEmitter: EventEmitter<null>;
  @ViewChild('modal') modal: ModalComponent;

  constructor() {
    this.confirmEmitter = new EventEmitter();
  }

  public open(toDate: string) {
    this.toDate = toDate;
    this.modal.open();
  }

  public confirm() {
    this.confirmEmitter.emit();
    this.modal.close();
  }

  cancel() {
    this.modal.close();
  }
}

export class DeleteModalOptions {
  data?: any;
  headline: string;
  subheading?: string;
}



// WEBPACK FOOTER //
// ./src/app/home/reports/modals/confirm-datalock-modal.component.ts